(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-header-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
        function setOpen(toggle, open) {
            var item = toggle.closest('.custom-drawer__item');
            toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
            item.classList.toggle('is-open', open);
            if (!open) {
                item.querySelectorAll('.custom-drawer__item.is-open').forEach(function (child) {
                    child.classList.remove('is-open');
                });
                item.querySelectorAll('[data-custom-drawer-toggle]').forEach(function (child) {
                    child.setAttribute('aria-expanded', 'false');
                });
            }
        }

        function toggleItem(toggle) {
            var opening = toggle.getAttribute('aria-expanded') !== 'true';
            if (opening) {
                // one open item per list: close its open siblings first
                var list = toggle.closest('.custom-drawer__list');
                list.querySelectorAll(':scope > .custom-drawer__item > .custom-drawer__row > [data-custom-drawer-toggle][aria-expanded="true"]').forEach(function (other) {
                    setOpen(other, false);
                });
            }
            setOpen(toggle, opening);
        }

        document.addEventListener('click', function (event) {
            var toggle = event.target.closest('[data-custom-drawer-toggle]');
            if (toggle) toggleItem(toggle);
        });

        document.addEventListener('keydown', function (event) {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            var toggle = event.target.closest('[data-custom-drawer-toggle]');
            if (!toggle) return;
            event.preventDefault();
            toggleItem(toggle);
        });

        // when the drawer closes, collapse everything, then restore the
        // initial state (default or current-page items open)
        document.addEventListener('toggle', function (event) {
            var details = event.target;
            if (details.id !== 'Details-menu-drawer-container' || details.open) return;
            details.querySelectorAll('[data-custom-drawer-toggle][aria-expanded="true"]').forEach(function (toggle) {
                setOpen(toggle, false);
            });
            details.querySelectorAll('[data-initial-open]').forEach(function (toggle) {
                setOpen(toggle, true);
            });
        }, true);
    })();
  } catch(e) { console.error(e); }
})();

})();
